import { useState, useEffect } from "react";
import styled from "styled-components";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";

export const LoadingDocuments = ({
  loadingDocuments = false,
  succesData,
  setSuccesData,
  errorDocuments,
  setErrorDocuments,
}) => {
  const [loadingComponent, setLoadingComponent] = useState(false);
  useEffect(() => {
    if (loadingDocuments && !succesData) {
      setLoadingComponent(true);
    }

    if (succesData) {
      setTimeout(() => {
        setLoadingComponent(false);
      }, 1000);
      errorDocuments && setErrorDocuments("");
      setSuccesData(false);
    }

    if (errorDocuments !== "") {
      setLoadingComponent(true);
      setTimeout(() => {
        setLoadingComponent(false);
        setErrorDocuments("");
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingDocuments, succesData, errorDocuments]);

  return (
    <>
      {loadingComponent ? (
        <BgLoader>
          <LoadingDataSinester>
            {errorDocuments !== "" ? (
              <div
                style={{ display: "block", padding: "10px", color: "#ff3b3b" }}
              >
                <ContainerLoader>
                  <h1>X</h1>
                </ContainerLoader>
                <TextLoading>{errorDocuments}</TextLoading>
              </div>
            ) : (
              <div style={{ display: "block", padding: "10px" }}>
                <ContainerLoader>
                  <Stack sx={{ color: "grey.500" }}>
                    <CircularProgress color="success" />
                  </Stack>
                </ContainerLoader>
                <TextLoading>Cargando documentos</TextLoading>
              </div>
            )}
          </LoadingDataSinester>
        </BgLoader>
      ) : (
        <></>
      )}
    </>
  );
};

const BgLoader = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgb(0 0 0 / 45%);
  z-index: 99;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoadingDataSinester = styled.div`
  position: fixed;
  width: 40%;
  max-width: 300px;
  min-width: 120px;
  background-color: white;
  height: 20%;
  z-index: 100;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: rgb(0 0 0 / 28%) 1px 1px 10px 0px;
  text-align: center;
`;

const TextLoading = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1.3rem;
`;

const ContainerLoader = styled.p`
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
